export * as ruleset from './gifts.ruleset';
export * as getters from './gifts.getters';
export * as modifiers from './gifts.modifiers';

export type GiftType = 'energy' | 'bPoint' | 'gems';
